module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0067.jpg?v=23f11b37";